// extracted by mini-css-extract-plugin
export default {"boxEmpty":"Empty_boxEmpty__JMVas","text":"Empty_text__y0krj","btnAdd":"Empty_btnAdd__j4ya0"};